module.exports = __webpack_public_path__ + "static/media/apartment20.8511e164.jpg";